import React, { useState } from "react";
import { motion } from "framer-motion";
import { FaPhone, FaWhatsapp, FaEnvelope, FaInstagram, FaFacebook } from "react-icons/fa";
import FooterSection from "./landing/FooterSection";

const supportOptions = [
  {
    name: "Phone",
    icon: FaPhone,
    value: "+91 9207207469",
    action: "tel:+919207207469",
    bgColor: "bg-green-600",
    logoColor: "text-white",
    buttonText: "Call Now",
  },
  {
    name: "WhatsApp",
    icon: FaWhatsapp,
    value: "+91 9207207469",
    action: "https://wa.me/919207207469",
    bgColor: "bg-green-500",
    logoColor: "text-white",
    buttonText: "Message on WhatsApp",
  },
  {
    name: "Email",
    icon: FaEnvelope,
    value: "support@laynered.com",
    action: "mailto:official.laynered@gmail.com",
    bgColor: "bg-red-500",
    logoColor: "text-white",
    buttonText: "Send Email",
  },
  {
    name: "Instagram",
    icon: FaInstagram,
    value: "@layne_red",
    action: "https://www.instagram.com/layne_red?igsh=MW9hazVybmU4YmprMQ==",
    bgColor: "bg-gradient-to-r from-purple-500 via-pink-500 to-orange-500",
    logoColor: "text-white",
    buttonText: "Follow on Instagram",
  },
  {
    name: "Facebook",
    icon: FaFacebook,
    value: "Facebook",
    action: "https://www.facebook.com/share/14HmXRqcRf2/",
    bgColor: "bg-blue-600",
    logoColor: "text-white",
    buttonText: "Visit on Facebook",
  },
];

const Support = () => {
  const [selected, setSelected] = useState(null);

  const handleCardClick = (option) => {
    if (selected && selected.name === option.name) {
      setSelected(null); // Deselect if the same card is clicked
    } else {
      setSelected(option);
    }
  };

  return (
    <div className="min-h-screen bg-primary dark:bg-primary-dark flex flex-col items-center justify-center p-6">
      <motion.div
        className="max-w-3xl w-full bg-primary dark:bg-primary-dark rounded-2xl shadow-[0_0_20px_rgba(255,255,255,0.1)] p-8"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <h2 className="text-3xl font-bold text-black dark:text-secondary text-center mb-8">Contact Us</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {supportOptions.map(({ name, icon: Icon, value, action, bgColor, logoColor, buttonText }) => (
            <motion.div
              key={name}
              className={`${bgColor} rounded-xl p-6 flex flex-col items-center justify-between shadow-lg hover:shadow-xl transition-shadow duration-300 cursor-pointer min-h-[200px]`}
              onClick={() => handleCardClick({ name, icon: Icon, value, action, bgColor, logoColor, buttonText })}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              {selected && selected.name === name ? (
                <>
                  <motion.div
                    className="flex items-center gap-3"
                    initial={{ y: 20, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.5 }}
                  >
                    <Icon size={36} className={logoColor} />
                    <p className="text-xl font-semibold text-white">{name}</p>
                  </motion.div>
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4, delay: 0.2 }}
                    className="flex flex-col items-center"
                  >
                    <p className="text-sm text-white/70 mb-4 text-center">Connect with us on {name}</p>
                    <motion.a
                      href={action}
                      className="px-6 py-2 bg-white text-black rounded-full font-medium hover:bg-gray-200 transition-colors"
                      whileHover={{ scale: 1.1 }}
                      whileTap={{ scale: 0.9 }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {buttonText}
                    </motion.a>
                  </motion.div>
                </>
              ) : (
                <>
                  <Icon size={36} className={logoColor} />
                  <p className="text-white font-medium mt-3">{name}</p>
                </>
              )}
            </motion.div>
          ))}
        </div>
      </motion.div>
      <FooterSection />
    </div>
  );
};

export default Support;